export default [
  {
    value: 'general',
    text: 'General'
  },
  {
    value: 'follow_up',
    text: 'En seguimiento'
  },
  {
    value: 'spam',
    text: 'Spam'
  },
  {
    value: 'done',
    text: 'Listo'
  }
]
